import { Outlet } from 'react-router-dom';

export const BookingItem = () => {
  return <Outlet />;
};
